import Vue from "vue";

import _Payments from "./Payments";
export const Payments = Vue.component("payments", _Payments);

import _TopupWallet from "./TopupWallet";
export const TopupWallet = Vue.component("topup-wallet", _TopupWallet);
